import {pitchToStaffIndex} from '../widgets/staff/pitchMath.js';

export function usesSATBStems(config) {
  return config.phraseCompletion?.variant === 'harmonic-minor-open' || config.satbStems === true;
}
// In two-voice staves, S/T are the upper voice and A/B the lower voice.
// Resolve by vertical pitch rather than the order notes were entered.
export function grandStaffVoiceStemUp(config, staff, notes, index, fallback) {
  if (!usesSATBStems(config)) return fallback;
  if (notes.length < 2) return staff === 'treble';
  const order = notes.map((note, i) => ({i, height:pitchToStaffIndex(note.pitch, staff)}))
    .sort((a,b) => a.height-b.height || a.i-b.i);
  return index === order[order.length-1].i;
}

export function shouldAddResolutionUnison(config, matching, offsetX) {
  return !!config.dominantResolution && matching > 0 && offsetX >= matching * 13 - 2;
}
